import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ContactService } from 'src/app/services/contact.service';
import { Contact } from 'src/app/interfaces/contact';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  info: Contact[] = []

  constructor(private contact:ContactService, public translate :TranslateService) { }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe( ()=> {
      if(this.translate.currentLang == "en") {
        
        document.getElementById("gutters").classList.remove("flex-right")
        document.getElementById("vincent_сontact_block_1").classList.remove("direction_rtl")
        document.getElementById("vincent_сontact_block_2").classList.remove("direction_rtl")
        document.getElementById("vincent_сontact_block_3").classList.remove("direction_rtl")
        
        document.getElementById("content_1_1").classList.remove("right")
        document.getElementById("content_1_2").classList.remove("right")
        document.getElementById("content_1_3").classList.remove("right")
        document.getElementById("content_1_4").classList.remove("right")
        document.getElementById("content_1_5").classList.remove("right")
        document.getElementById("content_1_6").classList.remove("right")

        document.getElementById("content_2_1").classList.remove("right")
        document.getElementById("content_2_2").classList.remove("right")
        document.getElementById("content_2_3").classList.remove("right")
        document.getElementById("content_2_4").classList.remove("right")
        document.getElementById("content_2_5").classList.remove("right")
        document.getElementById("content_2_6").classList.remove("right")

        document.getElementById("content_3_1").classList.remove("right")
        document.getElementById("content_3_2").classList.remove("right")
        document.getElementById("content_3_3").classList.remove("right")
        document.getElementById("content_3_4").classList.remove("right")
        document.getElementById("content_3_5").classList.remove("right")
        document.getElementById("content_3_6").classList.remove("right")

        document.getElementById("vincent_button_1").classList.remove("float-right")
        document.getElementById("vincent_button_2").classList.remove("float-right")
        document.getElementById("vincent_button_3").classList.remove("float-right")

      }
      else if (this.translate.currentLang == "ar") {
        document.getElementById("gutters").classList.add("flex-right")
        document.getElementById("vincent_сontact_block_1").classList.add("direction_rtl")
        document.getElementById("vincent_сontact_block_2").classList.add("direction_rtl")
        document.getElementById("vincent_сontact_block_3").classList.add("direction_rtl")

        
        document.getElementById("content_1_1").classList.add("right")
        document.getElementById("content_1_2").classList.add("right")
        document.getElementById("content_1_3").classList.add("right")
        document.getElementById("content_1_4").classList.add("right")
        document.getElementById("content_1_5").classList.add("right")
        document.getElementById("content_1_6").classList.add("right")

        document.getElementById("content_2_1").classList.add("right")
        document.getElementById("content_2_2").classList.add("right")
        document.getElementById("content_2_3").classList.add("right")
        document.getElementById("content_2_4").classList.add("right")
        document.getElementById("content_2_5").classList.add("right")
        document.getElementById("content_2_6").classList.add("right")

        document.getElementById("content_3_1").classList.add("right")
        document.getElementById("content_3_2").classList.add("right")
        document.getElementById("content_3_3").classList.add("right")
        document.getElementById("content_3_4").classList.add("right")
        document.getElementById("content_3_5").classList.add("right")
        document.getElementById("content_3_6").classList.add("right")

        document.getElementById("vincent_button_1").classList.add("float-right")
        document.getElementById("vincent_button_2").classList.add("float-right")
        document.getElementById("vincent_button_3").classList.add("float-right")

      }
    })
  }
  done:boolean = false
  submit:boolean = true
  addcontact (f:NgForm) {
    this.submit = false
    let name = (<Contact>f.value).name,
        email = (<Contact>f.value).email,
        message = (<Contact>f.value).message;

        this.contact.confirmOrder(name,email,message)
        .then(()=> {
          this.done = true
          setTimeout(() => {
            this.submit = true
            this.done = false
          }, 4000);
        })

  }

}
